import { render, staticRenderFns } from "./SubMenuItemNew.vue?vue&type=template&id=30c99970&scoped=true&"
import script from "./SubMenuItemNew.vue?vue&type=script&lang=js&"
export * from "./SubMenuItemNew.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuItemNew.vue?vue&type=style&index=0&id=30c99970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c99970",
  null
  
)

export default component.exports